import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable()
export class BaseAuthGuard {
  protected router = inject(Router);
  protected authService = inject(AuthService);

  constructor() { }

  login(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (!this.authService.isSignOutRequested) {
      this.setReturnUrl(state);
      this.getForceParam(route);

      this.authService.login();
    }
  }

  private setReturnUrl(state: RouterStateSnapshot): void {
    const returnUrl = state.url?.startsWith('/') ? state.url : `/${state.url || ''}`;
    sessionStorage.setItem('returnUrl', returnUrl);
  }

  private getForceParam(route: ActivatedRouteSnapshot): void {
    const force = route.queryParams?.force;
    sessionStorage.setItem('force', force);
  }
}
